export default __webpack_public_path__ + "static/media/doctor-icon-bw.03346ed8.svg";